const accountOwner = ['Account Owner'];
const accountManager = ['Account Manager'];
const brandManager = ['Account Manager'];
const campaignManager = ['Account Manager'];
const contentCreater = ['Account Manager'];

const Account = [];

export const ManagementRoles = [
  'Account Manager',
  'Account Owner',
  'Brand Manager',
  'Team Manager',
];
